import type { Data } from '@puckeditor/core'
import { v4 } from 'uuid'
import { ButtonBlock } from './components/ButtonBlock'
import { HeadingBlock } from './components/Heading'
import { ParagraphBlock } from './components/Paragraph'
import { defaultPadding } from './components/PaddingField'

export const createDefaultPopupData = (): Data<Record<string, any>, Record<string, any>> => ({
    root: {
        props: {
            backgroundColor: '#FFFFFF',
            padding: { top: 24, right: 24, bottom: 24, left: 24 },
            borderRadius: 20,
            position: 'bottom_left',
            animation: 'fade',
            overlay: true,
            maxWidth: 480,
        },
    },
    content: [
        {
            type: 'Heading',
            props: {
                ...HeadingBlock.defaultProps,
                id: `Heading-${v4()}`,
                text: 'Headline',
                padding: defaultPadding,
            },
        },
        {
            type: 'Paragraph',
            props: {
                ...ParagraphBlock.defaultProps,
                id: `Paragraph-${v4()}`,
                text: 'Add your message here.',
                padding: defaultPadding,
            },
        },
        {
            type: 'Button',
            props: {
                ...ButtonBlock.defaultProps,
                id: `Button-${v4()}`,
            },
        },
    ],
})
